import clsx from 'clsx'
import LineLuxuryEscapesMonogramIcon from 'LuxKit/Icons/line/LineLuxuryEscapesMonogramIcon'
import { setSvgIconSize } from 'LuxKit/SvgIcon'
import BodyText from 'LuxKit/Typography/BodyText'
import {
  tierDarkBackgroundStyle,
  tierDarkContrastColorStyle,
  tierGradientBackgroundStyle,
  tierGradientSecondaryBackgroundStyle,
  tierNormalContrastColorStyle,
} from 'styles/utils/tierStyles'
import { rem } from 'polished'
import type { PropsWithChildren, ReactElement } from 'react'
import styled from 'styled-components'

const Container = styled.div`
  display: inline-flex;
  flex-grow: 0;
  max-width: fit-content;
  flex-direction: row;
  align-items: center;
  gap: ${rem(4)};
  border-radius: ${props => props.theme.borderRadius.round};
  min-height: ${rem(28)};
  padding: ${rem(2)} ${rem(8)};
  ${tierNormalContrastColorStyle}

  &.kind-primary {
    ${tierGradientBackgroundStyle}
  }

  &.kind-secondary {
    ${tierGradientSecondaryBackgroundStyle}
  }
`

const IconContainer = styled.div`
  flex-shrink: 0;
  flex-grow: 0;
  display: grid;
  place-items: center;
  height: ${rem(20)};
  width: ${rem(20)};
`

const StartIcon = styled(IconContainer)`
  ${setSvgIconSize(12)}
  border-radius: ${props => props.theme.borderRadius.round};
  ${tierDarkBackgroundStyle}
  ${tierDarkContrastColorStyle}
`

const EndIcon = styled(IconContainer)`
  ${setSvgIconSize(16)}
`

const Content = styled(BodyText)`
  flex-grow: 1;
`

interface Props extends PropsWithChildren {
  tier: App.LoyaltyTier
  kind: 'primary' | 'secondary'
  /**
   * @default Brand logo
   * TODO rename to startIcon
   */
  icon?: ReactElement | null
  endIcon?: ReactElement | false
  className?: string
}

function LoyaltyTierPill({
  tier,
  kind,
  icon = <LineLuxuryEscapesMonogramIcon />,
  endIcon,
  children,
  className,
}: Props) {
  return <Container className={clsx(className, `tier-${tier}`, `kind-${kind}`)}>
    {!!icon && <StartIcon className={clsx(`tier-${tier}`)}>{icon}</StartIcon>}
    <Content variant="small" weight="bold">{children}</Content>
    {!!endIcon && <EndIcon>{endIcon}</EndIcon>}
  </Container>
}

export default LoyaltyTierPill
